import React from 'react';
import { BaseComponent } from './../BaseComponent.js';
import moment from 'moment';
import { Pie } from 'react-chartjs-2';
import FontAwesome from 'react-fontawesome';
import { DateRangePicker } from 'react-dates';
import $ from 'jquery';
import * as zoom from 'chartjs-plugin-zoom-mv';

export default class PieChart extends BaseComponent {
  constructor(props) {
    super(props);

    let startDate = moment().subtract(1,'d');
    startDate = moment(startDate.format('YYYY-MM-DD') + ' 00:00:00', "YYYY-MM-DD HH:mm:ss");
    let endDate = moment(moment().format('YYYY-MM-DD') + ' 23:59:59', "YYYY-MM-DD HH:mm:ss");

    let graph = this.props.graph;

    this.state = {
      graph: graph,
      graphData: [],
      error: '',
      // data: this.props.data,
      data: [],
      id: this.props.id,
      limit: 1000,
      data: [],
      data_time_d: [],
      data_time_h: [],
      data_time_i: [],
      dataPreFormat: [],
      startDate: startDate,
      endDate: endDate,
      dataGroup: '1d',
      dataGroupSearch: '1d', // evita di cambiare le label al cambio della select
      hours: '00-01',
      formattedData: {},
      ajaxOpen: [],
      visible: false,
      address: [],
    };

    this.getDataFromStored = this.getDataFromStored.bind(this);
    this.removeModule = this.removeModule.bind(this);

    this.filterDate = this.filterDate.bind(this);
    this.backGraph = this.backGraph.bind(this);
    this.changeDataGroup = this.changeDataGroup.bind(this);

    this.barGraphZoom = this.barGraphZoom.bind(this);
    this.lineGraphClick = this.lineGraphClick.bind(this);
    this.changeDates = this.changeDates.bind(this);
    this.getFormattedData = this.getFormattedData.bind(this);


    this.getSavedData = this.getSavedData.bind(this);
    this.formatData = this.formatData.bind(this);
  }

  componentDidMount() {
    this.init();
  }

  init() {
    // this.getData();
    let mod = this.state.graph;
    console.log(mod);
    let i = 0;
    let devicesToQuery = [];
    let address = [];
    while (i < mod.data.length) {
      if (devicesToQuery.indexOf(mod.data[i].deviceID) === -1) {
        devicesToQuery.push(mod.data[i].deviceID);
      }
      if (mod.data[i].IEEEAddress) {
        address.push(mod.data[i].IEEEAddress);
      } else if(mod.data[i].address) {
        address.push(mod.data[i].address);
      }
      i++;
    }

    i = 0;
    this.setState({ openAjax: devicesToQuery.length, address: address, currentGraph: mod }, () => {
      while (i < devicesToQuery.length) {
        this.getSavedData(devicesToQuery[i]);
        i++;
      }
    });
  }

  // Scrive i dati MODBUS e ZIGBEE nello stato data e data_time
  getSavedData(deviceID, offset, queue = 0) {
    if (isNaN(offset)) {
      offset = 0;
    } else {
      offset = parseInt(offset, 10) + parseInt(this.state.limit, 10);
    }

    let data = {
      Action: 'GetStoredData',
      DeviceID: deviceID,
      Offset: offset,
      Queue: queue,
      Limit: this.state.limit,
    };
    if (this.state.startDate) {
      data.From = parseInt(this.state.startDate.format('X'), 10);
    }
    if (this.state.endDate) {
      data.To = parseInt(this.state.endDate.format('X'), 10);
    }
    data = JSON.stringify(data);

    console.log(deviceID);
    $.ajax({
      method: 'POST',
      url: 'https://sparkjvm.com/cloud/json',
      headers: {
        'x-session': this.props.token,
      },
      dataType: 'json',
      data: data,
      xhrFields: {
        withCredentials: true
      },
      success: (res) => {
        let i = 0;
        let data = this.state.data;
        let dataPreFormat = this.state.dataPreFormat;

        console.log('%c CHIAMATA ', 'background: #222; color: #bada55');
        console.log(res);
        while (i < res.Data.length) {
          res.Data[i]['timestamp'] = res.Timestamp[i];

          if (!data[deviceID]) {
            data[deviceID] = [];
          }

          let j = 0;
          // CICLO ALL'INTERNO DEI SENSORI
          // ZIGBEE - DATI PER GRAFICO
          if (res.Data[i].Nodes) {
            console.log('ENTRA ZIGBEE');
            data[deviceID].push(res.Data[i].Nodes);
            // data[deviceID].push(res.Data[i].Nodes);
            while (j < res.Data[i].Nodes.length) {
              let sensor = res.Data[i].Nodes[j];
              // CICLO ALL'INTERNO DEGLI ENDPOINT
              if (this.state.address.indexOf(sensor.IEEEAddress) !== -1) {
                let z = 0;
                while (z < sensor.Endpoints.length) {
                  let endpoint = sensor.Endpoints[z];
                  endpoint.IEEEAddress = sensor.IEEEAddress;
                  endpoint.gatewayID = deviceID;
                  endpoint.timestamp = res.Timestamp[i];
                  endpoint.type = 'zigbee';
                  dataPreFormat.push(endpoint);
                  z++;
                }
              }
              j++;
            }
          } else {
            console.log('ENTRA MODBUS');
            data[deviceID].push(res.Data);
            // TO DO: MODBUS
            // MODBUS - DATI PER GRAFICO
            // data[deviceID].push(res.Data);
            console.log(res.Data[i]);
            let sensor = res.Data[i];
            let z = 0;

            while (z < sensor.length) {
              let endpoint = sensor[z];
              console.log(this.state.address);
              console.log(endpoint.Id);
              if (this.state.address.indexOf(endpoint.Id) !== -1) {
                console.log('LOAD MODULE DATA');
                endpoint.IEEEAddress = endpoint.Id;
                endpoint.gatewayID = deviceID;
                endpoint.timestamp = res.Data[i].timestamp;
                endpoint.type = 'modbus';
                dataPreFormat.push(endpoint);
              }
              z++;
            }
            j++;
          }
          i++;
        }

        // let ajaxOpen = this.state.ajaxOpen;
        // ajaxOpen[deviceID] = ajaxOpen[deviceID] - 1;

        this.setState({ data: data, dataPreFormat: dataPreFormat }, () => {
          // CODA 0 -> zigbee
          if (queue === 0) {
            // Cerco se ci sono altri dati oltre ai 1000 di limite
            if (res.Limit === res.Count) {
              this.getSavedData(deviceID, res.Offset, queue);
            } else {
              // passo al reperimento dati in modbus che risiedono sulla coda 1
              this.getSavedData(deviceID, null, 100);
            }
          // CODA 1 -> modbus
          } else if(queue === 100) {
            if (res.Limit === res.Count) {
              this.getSavedData(deviceID, res.Offset, queue);
            } else {
              let openAjax = this.state.openAjax-1;
              console.log('FINE');
              this.setState({ openAjax: openAjax}, () => {
                if (this.state.openAjax === 0) {
                  this.formatData();
                }
              });
            }
          }
        });
      },
      error: (httpReq, status, exception) => {
        console.log(httpReq);
        console.log(status);
        console.log(exception);
      },
    });
  }


  formatData() {
    console.log('INIT FORMAT DATA');
    console.log(this.state.dataPreFormat);
    let data_time_d = [];
    let data_time_h = [];
    let data_time_i = [];

    let i = 0;
    while (i < this.state.dataPreFormat.length) {
      console.log('FORMAT');
      let endpoint = this.state.dataPreFormat[i];

      let timestampRounded = moment.unix(endpoint.timestamp);

      // PER OGNI DATO SALVATO MODIFICO LA SUA DATA ARROTONDANDOLA
      let timestampRoundedFormat;

      // SALVO 3 DATE_TIME GIÀ FORMATTATI
      // FORZO A MINUTI
      timestampRoundedFormat = timestampRounded.format('YYYY-MM-DD HH:mm');
      timestampRoundedFormat = moment(timestampRoundedFormat + ':00', 'YYYY-MM-DD HH:mm:ss');

      timestampRoundedFormat = timestampRoundedFormat.format('X');
      endpoint.timestampRounded = timestampRoundedFormat;
      // FINE MODIFICA DATA - POI AGGIUNGO I DATI SOMMANDOLI

      // SMISTAMENTO DATI CON ARROTONDAMENTO
      if (!data_time_i[timestampRoundedFormat]) {
        data_time_i[timestampRoundedFormat] = [];
      }
      if (!data_time_i[timestampRoundedFormat][endpoint.IEEEAddress]) {
        data_time_i[timestampRoundedFormat][endpoint.IEEEAddress] = [];
      }
      data_time_i[timestampRoundedFormat][endpoint.IEEEAddress].push(endpoint);

      // FORZO A ORE
      timestampRoundedFormat = timestampRounded.format('YYYY-MM-DD HH');
      timestampRoundedFormat = moment(timestampRoundedFormat + ':00:00', 'YYYY-MM-DD HH:mm:ss');

      timestampRoundedFormat = timestampRoundedFormat.format('X');
      endpoint.timestampRounded = timestampRoundedFormat;
      // FINE MODIFICA DATA - POI AGGIUNGO I DATI SOMMANDOLI

      // SMISTAMENTO DATI CON ARROTONDAMENTO
      if (!data_time_h[timestampRoundedFormat]) {
        data_time_h[timestampRoundedFormat] = [];
      }
      if (!data_time_h[timestampRoundedFormat][endpoint.IEEEAddress]) {
        data_time_h[timestampRoundedFormat][endpoint.IEEEAddress] = [];
      }
      data_time_h[timestampRoundedFormat][endpoint.IEEEAddress].push(endpoint);


      // FORZO A GIORNI
      timestampRoundedFormat = timestampRounded.format('YYYY-MM-DD');
      timestampRoundedFormat = moment(timestampRoundedFormat + ' 00:00:00', 'YYYY-MM-DD HH:mm:ss');

      timestampRoundedFormat = timestampRoundedFormat.format('X');
      endpoint.timestampRounded = timestampRoundedFormat;
      // FINE MODIFICA DATA - POI AGGIUNGO I DATI SOMMANDOLI

      // SMISTAMENTO DATI CON ARROTONDAMENTO
      if (!data_time_d[timestampRoundedFormat]) {
        data_time_d[timestampRoundedFormat] = [];
      }
      if (!data_time_d[timestampRoundedFormat][endpoint.IEEEAddress]) {
        data_time_d[timestampRoundedFormat][endpoint.IEEEAddress] = [];
      }
      data_time_d[timestampRoundedFormat][endpoint.IEEEAddress].push(endpoint);

      i++;
    }

    this.setState({
      data_time_d: data_time_d,
      data_time_h: data_time_h,
      data_time_i: data_time_i,
      visible: true,
    }, () => {
      console.log(this.state);
      this.getFormattedData();
      this.setState({ popupGraph: true });
    });
  }

/*
    if (update) {
      this.setState({ data_time_i: newDataTimeI, data_time_d: newDataTimeD, data_time_h: newDataTimeH }, () => {
        let graphId = "graph_" + this.state.data.id;
        let graphRef = this.refs[graphId];
        graphRef.chartInstance.resetZoom();

        this.getFormattedData();
      });
    }
*/

  filterDate() {
    this.setState({ graphData: [], error: '', data: [], data: [], data_time_d: [], data_time_h: [], data_time_i: [], dataPreFormat: [], formattedData: {}, ajaxOpen: [], visible: false, address: [] }, () => {
      this.init();
    });
  }

  getObjFromEndpoint(params, string, name, deviceID, IEEEAddress, endpoint, array) {
    let i = 0;
    let val = endpoint;
    let add = true;
    while (i < params.length) {
      if (val.hasOwnProperty(params[i])) {
        val = val[params[i]];
      } else {
        add = false;
      }
      i++;
    }

    let obj;
    if (add) {
      obj = {
        name: name,
        deviceID: deviceID,
        IEEEAddress: IEEEAddress,
        endpointID: endpoint.Id,
        added: false,
        type: string,
        color: '#000',
        protocol : 'zigbee',
      };
      array.push(obj);
    }
    return array;
  }

  changeDataGroup(e) {
    this.setState({ dataGroup : e.target.value });
  }

  removeModule(id) {
    let dashboard = [];
    let i = 0;
    while (i < this.state.graphs.length) {
      if (this.state.graphs[i].id !== id) {
        dashboard.push(this.state.graphs[i]);
      }
      i++;
    }
    this.setState({ graphs: dashboard });
    this.saveGraphsToDb(dashboard);
  }

  getDataFromStored(dataObj) {
    let i = 0;
    let values = [];
    if (this.props.data[dataObj.deviceID] && this.props.data[dataObj.deviceID].length) {
      let device = this.props.data[dataObj.deviceID];
      while (i < device.length) {
        let j = 0;
        while (j < device[i].length) {
          let subDevice = device[i][j];
          if (dataObj.IEEEAddress === subDevice.IEEEAddress) {
            let z = 0;
            while (z < subDevice.Endpoints.length) {
              let endpoint = this.props.data[dataObj.deviceID][i][j].Endpoints[z];
              if (endpoint.Id === dataObj.endpointID) {
                let params = dataObj.type.split('.');
                let ii = 0;
                let val = endpoint;
                let err = false;
                while (ii < params.length) {
                  if (val.hasOwnProperty(params[ii])) {
                    val = val[params[ii]];
                  } else {
                    err = true;
                  }
                  ii++;
                }
                if (!err) {
                  let value = {
                    timestamp: device[i].timestamp,
                    name: dataObj.name,
                    val: val,
                  };
                  values.push(value);
                }
              }
              z++;
            }
          }
          j++;
        }
        i++;
      }
    }
    return values;
  }

  backGraph() {
    this.setState({
      startDate: this.state.initStartDate,
      endDate: this.state.initEndDate,
      dataGroupSearch: '1d',
      dataGroup: '1d',
    }, () => {
      this.changeView();
    });
  }

  lineGraphClick(e, el) {
    if (el && el.length) {
      el = el[0];
      // let data = el._model.label;

      if (el._chart.getElementsAtEvent(e)) {
        let index = el._chart.getElementsAtEvent(e)[0]._index;
        let data = el._chart.config.data.labels[index];
        // INDEX PER INDICE DEL PUNTO NEL DATASET

        if (data) {
          let startDate;
          let endDate;
          let dataGroup;
          // let hours = '00-01';
          if (this.state.dataGroupSearch === '1d') {
            this.setState({
              initStartDate: this.state.startDate,
              initEndDate: this.state.endDate,
            });
          }
          if (this.state.dataGroupSearch === '1d' || this.state.dataGroupSearch === '1h') {
            startDate = moment(data + ' 00:00:00', "YYYY-MM-DD HH:mm:ss");
            endDate = moment(data + ' 23:59:59', "YYYY-MM-DD HH:mm:ss");
            if (this.state.dataGroupSearch === '1d') {
              dataGroup = '1h';
            } else if(this.state.dataGroupSearch === '1h') {
              let h1 = startDate.hours();
              let h2 = h1+1;
              h1 = '' + h1;
              h2 = '' + h2;
              if (h1.length < 2) {
                h1 = '0' + h1;
              }
              if (h2.length < 2) {
                h2 = '0' + h2;
              }
              let data_arr = data.split(' ');
              startDate = moment(data_arr[0] + ' ' + h1 + ':00:00', "YYYY-MM-DD HH:mm:ss");
              endDate = moment(data_arr[0] + ' ' + h2 + ':00:00', "YYYY-MM-DD HH:mm:ss");
              dataGroup = '1i';
              // hours = h1 + '-' + h2;
            }
            this.setState({
              startDate: startDate,
              endDate: endDate,
              dataGroup: dataGroup,
              dataGroupSearch: dataGroup,
            }, () => {
              this.changeView();
            });
          }
        }
      }
    }
  }

  changeView() {
    this.getFormattedData();
  }

  barGraphZoom(zoom) {
  }

  changeDates(dates) {
    dates.startDate = moment(dates.startDate.format('YYYY-MM-DD') + ' 00:00:00', "YYYY-MM-DD HH:mm:ss");
    if (dates.endDate) {
      dates.endDate = moment(dates.endDate.format('YYYY-MM-DD') + ' 23:59:59', "YYYY-MM-DD HH:mm:ss");
    } else {
      dates.endDate = null;
    }
    this.setState({ startDate: dates.startDate, endDate: dates.endDate });
  }

  getFormattedData() {
    console.log();
    let data = this.state.graph.data;
    let labels = [];
    let colors = [];
    let datasetsContent = [];

    // Array con chiave data ed ora, come valori array con chiave IEEEAddress e come valore tutte le registrazioni effettuate in quell'ora
    let d;

    if (this.state.dataGroupSearch === '1h') {
      d = this.state.data_time_h;
    } else if(this.state.dataGroupSearch === '1d') {
      d = this.state.data_time_d;
    } else if(this.state.dataGroupSearch === '1i') {
      d = this.state.data_time_i;
    }

    for (var kk in d) {
      let dateArr = d[kk];

      let timestampRounded = moment.unix(kk);
      let key;
      if (this.state.dataGroupSearch === '1h') {
        key = timestampRounded.format('YYYY-MM-DD HH:mm');
      } else if(this.state.dataGroupSearch === '1d') {
        key = timestampRounded.format('YYYY-MM-DD');
      } else if(this.state.dataGroupSearch === '1i') {
        key = timestampRounded.format('YYYY-MM-DD HH:mm');
      }

      let i = 0;
      let insert = false;
      while (i < data.length) {
        console.log(data[i]);
        console.log(data);
        if (dateArr[data[i].IEEEAddress]) {
          let params = data[i].type.split('.');

          let ii = 0;
          let dataMediaVal = 0;
          let dataMediaCount = 0;
          while (ii < dateArr[data[i].IEEEAddress].length) {
            let jj = 0;
            let err = false;
            let dataMedia = dateArr[data[i].IEEEAddress][ii];
            while (jj < params.length) {
              if (dataMedia.hasOwnProperty(params[jj])) {
                dataMedia = dataMedia[params[jj]];
              } else {
                err = true;
              }
              jj++;
            }
            if (!err) {
              dataMediaVal += dataMedia;
              dataMediaCount++;
            }
            ii++;
          }
          if (!isNaN(dataMediaVal) && dataMediaCount > 0) {
            insert = true;
            dataMediaVal = Math.round(dataMediaVal / dataMediaCount);

            if (!datasetsContent[data[i].name]) {
              datasetsContent[data[i].name] = [];
            }
            datasetsContent[data[i].name].push(dataMediaVal);
          }
        } else {
          // REPERIMENTO MODBUS
          dateArr[data[i].address]

          let ii = 0;
          let dataMediaVal = 0;
          let dataMediaCount = 0;
          if (dateArr[data[i].address]) {
            while (ii < dateArr[data[i].address].length) {
              // let jj = 0;
              let err = false;
              let dataMedia = dateArr[data[i].address][ii];

              // while (jj < params.length) {
                if (dataMedia.hasOwnProperty(data[i].codeName)) {
                  dataMedia = dataMedia[data[i].codeName];
                } else {
                  err = true;
                }
                // jj++;
              // }
              if (!err) {
                dataMediaVal += dataMedia;
                dataMediaCount++;
              }

              ii++;
            }
          }

          if (!isNaN(dataMediaVal) && dataMediaCount > 0) {
            insert = true;
            dataMediaVal = Math.round(dataMediaVal / dataMediaCount);

            if (!datasetsContent[data[i].name]) {
              datasetsContent[data[i].name] = [];
            }
            datasetsContent[data[i].name].push(dataMediaVal);

          }
        }
        colors[data[i].name] = data[i].color;
        i++;
      }
      if (insert) {
        labels.push(key);
      }
    }
    let formattedData = {
      datasetsContent: datasetsContent,
      colors: colors,
      labels: labels,
    };

    this.setState({ formattedData: formattedData, visible: true });
  }

  renderBackClick() {
    if (this.state.initStartDate && this.state.initEndDate && this.state.dataGroupSearch !== '1d') {
      return(
        <button className="button button--right" onClick={ this.backGraph }>INDIETRO</button>
      );
    }
    return '';
  }

  hexToRgba(hex, opacity) {
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
      return r + r + g + g + b + b;
    });

    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (result) {
      return 'rgba(' + parseInt(result[1], 16) + ', ' + parseInt(result[2], 16) + ', ' + parseInt(result[3], 16) + ', ' + opacity + ')';
    }
    return hex;
  }

  render() {
    let datasets = [];
    let data = this.state.formattedData;
    console.log(this.state);

    for (var kkk in data.datasetsContent) {
      let dataset = {
        label: kkk,
        data: data.datasetsContent[kkk],
        backgroundColor: this.hexToRgba(data.colors[kkk], '0.8'),
        pointBackgorundColor: this.hexToRgba(data.colors[kkk], '0.7'),
        pointHoverBackgroundColor: this.hexToRgba(data.colors[kkk], '1'),
        borderColor: data.colors[kkk],
        borderWidth: 2,
        pointHoverBorderWidth: 4,
      };
      datasets.push(dataset);
    }

    let labels = [];
    let datasetsValues = [{
      data: [],
      backgroundColor: [],
      hoverBackgroundColor: [],
    }];
    let a = 0;
    while (a < datasets.length) {
      labels.push(datasets[a].label);

      let b = 0;
      let val = 0;
      while (b < datasets[a].data.length) {
        val += datasets[a].data[b];
        b++;
      }
      datasetsValues[0].data.push(val);

      datasetsValues[0].backgroundColor.push(datasets[a].backgroundColor);
      datasetsValues[0].hoverBackgroundColor.push(datasets[a].borderColor);
      a++;
    }

    let dataGraph = {
    	labels: labels,
    	datasets: datasetsValues,
    };

    let options = {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      },
    };

    let date_from = "date_from_" + data.id;
    let date_to = "date_to_" + data.id;
    let graphId = "graph_" + data.id;

    if (this.state.visible) {
      console.log(dataGraph);
      return (
        <div className="dashboard">
          <div className="dashboard__search">
            <div className="dashboard__search__col">
              <span className="dashboard__search__col__label">Seleziona date</span>
              <DateRangePicker
                startDatePlaceholderText="Da"
                endDatePlaceholderText="A"
                startDate={ this.state.startDate }
                startDateId={ date_from }
                endDate={ this.state.endDate }
                endDateId={ date_to }
                onDatesChange={ this.changeDates }
                focusedInput={this.state.focusedInput}
                onFocusChange={focusedInput => this.setState({ focusedInput })}
                hideKeyboardShortcutsPanel={true}
                isOutsideRange={() => false}
                minimumNights={0}
              />
            </div>
            <button className="button" onClick={ this.filterDate }>FILTRA</button>
            { this.renderBackClick() }
          </div>
          <Pie data={ dataGraph } options={ options } ref={ graphId } />
        </div>
      );
    } else {
      return (
        <div className="loader loader--relative">
          <div className="loader__content">
            <FontAwesome
              className='loader__content__icon'
              name='spinner'
              spin
            />
          </div>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/PieChart.js